import { Fragment, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PackageOfflineResponse, PckRoom } from 'ts/package/interfaces/PackageOfflineResponse';
import ExpiredToken from 'components/shared/ExpiredToken';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import PackageOfflineDetails from './PackageDetails';
import TicketDetails from './TicketDetails';
import PackageInfo from './PackageInfo';
import HotelDetails from './HotelDetails';
import DetailsPackageSkeleton from '../Details/DetailsPackageSkeleton';
import { getOfflinePackage } from 'services/package';
import { saveScreenshot } from 'utils/utils';

const PackageOfflineDetailsPage = () => {
  const [urlParams] = useSearchParams();
  const [response, setResponse] = useState<PackageOfflineResponse>();
  const [selectedRoomKey, setSelectedRoomKey] = useState('');
  const [pckRoom, setPckRoom] = useState<PckRoom>();
  const detailsRef = useRef<HTMLDivElement>(null);
  useGetPage('ILPackage/Details');

  useEffect(() => {
    (async () => {
      const response = await getOfflinePackage(urlParams.get('name') || '');
      setResponse(response);
      if (response?.dealModel.package.oneItemPrice.listOfpckRoomTypeList?.[0]?.pckRooms?.length) {
        setSelectedRoomKey(
          response?.dealModel.package.oneItemPrice.listOfpckRoomTypeList[0].pckRooms[0].uKey || ''
        );
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onChangeRoom = (room: PckRoom, uKey: string) => {
    setSelectedRoomKey(uKey);
    setPckRoom(room);
  };

  return (
    <div className="details-wrapper package-details-wrapper" ref={detailsRef}>
      {!!response && !response?.hasErrors && !response.sessionExpired && (
        <Fragment>
          <div className="details package-details">
            <PackageOfflineDetails deal={response.dealModel} choosenRoom={pckRoom} />
            <TicketDetails
              bound={response.dealModel.package.flightOutBound}
              type="departure"
              remarks={response.dealModel.package.flightRemarks}
            />
            <TicketDetails
              bound={response.dealModel.package.flightInBound}
              type="return"
              remarks={response.dealModel.package.flightRemarks}
            />
            {response.dealModel.package.productType !== 'FLTM' && (
              <PackageInfo deal={response.dealModel} />
            )}
            <HotelDetails
              dealModel={response.dealModel}
              onChangeRoom={onChangeRoom}
              selectedRoomKey={selectedRoomKey}
              onClickBook={() => saveScreenshot(detailsRef.current, 'Details', 'OfflinePackages')}
            />
          </div>
          <div className="package-summary">
            <div className="default-shadow package-summary-map">
              {response.googleMapOfAirports && <img src={response.googleMapOfAirports} alt="map" />}
            </div>
          </div>
        </Fragment>
      )}

      {!!response?.sessionExpired && <ExpiredToken storePath="ilpackage" />}

      {!response && <DetailsPackageSkeleton />}
    </div>
  );
};

export default withErrorBoundary(PackageOfflineDetailsPage, 'PackageOfflineDetailsPage');
